import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CoreModule } from '@app/core/core.module';
import { ResponsiveState } from '@app/core/states/responsive.state';
import { UiModule } from '@app/ui';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { NgxsModule } from '@ngxs/store';
import { BaseChartDirective } from 'ng2-charts';
import { NotificationsModule } from '../notifications/notifications.module';
import { DataChartComponent } from './components/data-chart/data-chart.component';
import { StatisticsDashboardComponent } from './components/statistics-dashboard/statistics-dashboard.component';
import { StatisticsEmptyStateComponent } from './components/statistics-empty-state/statistics-empty-state.component';
import { StatisticsShellComponent } from './components/statistics-shell/statistics-shell.component';
import { StatisticsState } from './states/statistics.state';

@NgModule({
  declarations: [
    StatisticsDashboardComponent,
    DataChartComponent,
    StatisticsShellComponent,
  ],
  imports: [
    FontAwesomeModule,
    BaseChartDirective,
    CommonModule,
    CoreModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    UiModule,
    NotificationsModule,
    TranslateModule,
    NgxsModule.forFeature([StatisticsState, ResponsiveState]),
    StatisticsEmptyStateComponent,
  ],
  providers: [DatePipe, DecimalPipe],
})
export class StatisticsModule {}
